import { Card, Progress } from 'antd'
import getTemplate from './templates'

ActionsPage = ({ component, title, props... }) ->

  Template = getTemplate(component, props.componentConf)

  (props) ->
    <Card title={title}>
      <Template {props...}/>
    </Card>

export default ActionsPage
